import { MiniLink } from '@yimoka/mini-router';
import type { ReactNode } from 'react';

import { LanguageSwitcher } from '@/components/language-switcher';
import { useTranslation } from '@/locales/i18n';
import { useRealmBrand } from '@/realm-profile/profile';

import { useSsoStyles } from './index.style';

interface SsoLayoutProps {
  children: ReactNode;
  headerExtra?: ReactNode;
}

/** SsoLayout 为认证入口提供统一品牌头部，并允许具体认证页面注入右上角操作。 */
export function SsoLayout({ children, headerExtra }: SsoLayoutProps) {
  const { styles } = useSsoStyles();
  const { t } = useTranslation();
  const brand = useRealmBrand(t('Account:brand.title'));

  return (
    <div className={styles.layout}>
      <header className={styles.header}>
        <div className={styles.headerInner}>
          <MiniLink className={styles.brand} data-testid="sso-brand" to="/">
            <img alt={brand.logoAlt} className={styles.logo} src={brand.logoURL} />
            <span className={styles.title}>{brand.shortTitle}</span>
          </MiniLink>
          <div className={styles.headerActions}>
            {headerExtra}
            <LanguageSwitcher className={styles.languageSwitcher} />
          </div>
        </div>
      </header>
      <main className={styles.content}>{children}</main>
    </div>
  );
}
